import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  FormModeEnum,
  ToolbarItem,
  TableSettings,
  NotificationService,
  ModalService,
  BackendService,
  FieldStructure,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { ActionType } from '../../../enums/action-type.enum';

@Component({
  selector: 'app-cenovnici',
  templateUrl: './cenovnici.component.html',
})
export class CenovniciComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  public showDetails = false;
  public orderListOdluke: any[];
  public settingsTableDetailsChild: TableSettings;
  public selectedKorekcija: any = null;
  public selectedOdluka: any;
  public settingsTableOdluke: TableSettings;
  public hasOdluke = false;
  public validateSubject: Subject<any> = new Subject<any>();
  public validateSubject$ = this.validateSubject.asObservable();

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Novi cenovnik';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Cenovnik';
    }
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSCEN_CEN,
          FormName.PregledCenovnika,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.disableInlineActions(data['Settings']);
            this.setSettings(data['Settings']);
          }
          this._data = data['ServiceData']['Data'];
          this.orderListCount = data['ServiceData']['DataSumCount'];
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  refreshTable() {
    const data = {
      documentId: 'PregledCenovnika',
      result: this._data,
      pageSize: 10,
      pageNumber: 1,
      count: this.orderListCount,
      menuCalled: false,
      error: 0,
    };

    this._data.forEach((o, i) => (o.id = i));
    this.setRbr(this._data);
    this.orderList = data.result;
  }

  onCancel() {
    this.copyProperties(this._orderBeforeEditing, this.order);
    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.View);
  }

  addOrder() {
    this.actionType = ActionType.Create;
    this.validateSubject.next();
  }

  createCenovnik() {
    this._spinner.show();
    const payload = { ...this.order };

    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSCEN_CEN, FormName.PregledCenovnika, payload)
        .subscribe(data => {
          this.openServiceError(data);
          this.loadSettings();
        })
    );
  }

  updateCenovnik() {
    this._spinner.show();
    const payload = { ...this.order };

    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSCEN_CEN, FormName.PregledCenovnika, payload)
        .subscribe(data => {
          this.openServiceError(data);
          this.loadSettings();
        })
    );
  }

  updateOrder() {
    this.actionType = ActionType.Update;
    this.validateSubject.next();
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSCEN_CEN, FormName.PregledCenovnika, this.order.Id)
        .subscribe(() => {
          this._notificationService.openNoty('Uspešno brisanje');
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  onTableMode() {
    if (this.infobarVisible) {
      this.infobarVisible = false;
    }
  }

  onTableActionView() {
    this.setToolbarOptions({
      items: [ToolbarItem.ItemEdit(true, !this.order.status)],
    });
    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.View);
    this.setInfobar(true, 'Marina Milenkovic', 1558801076316);
  }

  onTableActionAdd() {
    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.Add);
  }

  validirano(isValid: boolean) {
    if (isValid) {
      switch (this.actionType) {
        case ActionType.Create:
          this.createCenovnik();
          break;
        case ActionType.Update:
          this.updateCenovnik();
          break;
      }
    } else {
      this._notificationService.notyError('Niste uneli sva obavezna polja!');
    }
  }

  fetchSingleEntity() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSCEN_CEN,
          FormName.PregledCenovnika,
          EndpointTypes.SingleEntity,
          '',
          this.order.Id
        )
        .subscribe(data => {
          this._spinner.hide();
          data.Settings.details[1].allFields[1].path = 'Sifra';
          this.fieldStructure = new FieldStructure(data.Settings, 'header');
          this.settingsTableDetails = new TableSettings(
            data.Settings.details[0],
            'table'
          );

          if (this.order.Id) {
            this.onViewModeWithParams(
              data.Privilegije.includes('MSCEN_CEN_CREATE'),
              data.Privilegije.includes('MSCEN_CEN_DELETE'),
              data.Privilegije.includes('MSCEN_CEN_UPDATE')
            );
          }
          this.showDetails = true;
        })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/cenovnici/cenovnici.component.ts